import { BADI_COLORS, BUTTON_TYPES, Button } from "app/badi-components";
import React from "react";
import styled from "styled-components";
import Image from "components/Image";
import { Text, Heading } from "@badi/badi-components";
import { PriorityIcon } from "../fast-track/icons";
import { translate } from "base/shared/Localization";
import InjectHtml from "../inject-html/inject-html";

const FeedbackFastTrackWrapper = styled.div`
  background: ${BADI_COLORS.GRADIENT.GRADIENT_02};
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 25px;
  padding-top: 60px;
`;

const HeadingAndTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 5px;
  gap: 15px;
  align-self: start;
`;

const FeedbackFastTrack = ({ standardEnquiriesCount, onGotItClick }) => (
  <FeedbackFastTrackWrapper dataQa="message-enquiry-feedback-fast-track">
    <Image
      alt="fast track message successfully sent"
      src="/assets/images/fast-track/fast-track-chat-sent.svg"
    />
    <HeadingAndTextWrapper>
      <Heading style={{ marginLeft: "20px" }}>
        {translate("enquiry.fast-track.enquiry-sent.title")}
      </Heading>
      <Text>
        <InjectHtml>
          {translate("enquiry.fast-track.enquiry-sent.body.1")}
        </InjectHtml>
      </Text>
      <PriorityIcon />
      <Text>
        {standardEnquiriesCount > 0
          ? translate("enquiry.fast-track.enquiry-sent.body.2", {
              smart_count: standardEnquiriesCount,
            })
          : translate("enquiry.fast-track.enquiry-sent.body.2-no-count")}
      </Text>
    </HeadingAndTextWrapper>
    <Button
      style={{ alignSelf: "flex-end" }}
      fullWidth
      variant={BUTTON_TYPES.PRIMARY_INVERTED}
      onClick={onGotItClick}
    >
      {translate("enquiry.fast-track.enquiry-sent.close-button")}
    </Button>
  </FeedbackFastTrackWrapper>
);

export default FeedbackFastTrack;
